export default __webpack_public_path__ + "static/media/include_7_male@3x.6506d592.jpg";